<template>
  <div id="top-bar">
    <div class="top-container">
      <div style="display: flex;flex-flow: column;justify-content: center;align-items: center;width: 300px">
        <img @click="$router.push('/')" src="@/assets/logo.png" alt="" class="logo"/>
        <img @click="$router.push('/')" src="@/assets/logo_1.png" alt="" class="logo1"/>
      </div>
      <div class="right">
        <div class="category">
          <div class="category-wrap" @click="tab = -1" :class="{ active: tab == -1 }">
            首页
          </div>
          <div class="category-wrap" @click="tab = 1" :class="{ active: tab == 1 }">
            全部直播
          </div>
          <div v-if="!$store.getters.token" class="category-wrap" @click="goTab" :class="{ active: tab == 2 }">
            直播人气榜
          </div>
          <div v-else class="category-wrap" @click="tab = 2" :class="{ active: tab == 2 }">
            直播人气榜
          </div>

        </div>
        <div class="search-bar">
          <img class="search-icon" src="@/assets/search-logo.png" alt=""/>
          <div class="border"></div>
          <input v-model="content" @keydown="search" type="text" placeholder="搜索直播"
                 placeholder-style="color: rgb(144, 188, 156);"/>
        </div>
        <el-dropdown v-if="$store.getters.token" class="avatar-container right-menu-item hover-effect" trigger="hover">
          <img :src="$store.getters.avatar || avatar" alt="" class="user-avatar"/>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/profile" @click.native="go">
              <el-dropdown-item>个人资料</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click.native="logout">
              <span style="display:block;text-align:center;">登出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
<!--        <div v-if="!$store.getters.token" @click="$router.push('/login')" class="top-btn" style="margin-left: 30px;">-->
<!--          登录-->
<!--        </div>-->
        <div v-if="!$store.getters.token" @click="$refs['loginName'].showlogin()" class="top-btn" style="margin-left: 30px;">
          登录
        </div>
        <div v-if="!$store.getters.token" @click="$refs['register'].showRegisterDialog()" class="top-btn" style="margin-right: 20px;margin-left: 20px;">
          注册
        </div>
<!--        <div v-if="!$store.getters.token" @click="$router.push('/register')" class="top-btn" style="margin-right: 20px;margin-left: 20px;">-->
<!--          注册-->
<!--        </div>-->
        <div v-if="$store.getters.token" @click="goMyList" class="top-btn" style="margin-right: 20px;">
          {{ form.username }}
        </div>
      </div>
    </div>
<!--    <el-dialog :visible.sync="showLogin" :show-close="false" width="500px" >-->
      <login-name ref="loginName"></login-name>
<!--    </el-dialog>-->
<!--    <el-dialog :visible.sync="showRegister" :show-close="false" width="700px" >-->
      <register ref="register"></register>
<!--    </el-dialog>-->
  </div>
</template>

<script>
import LoginName  from '@/views/login/index.vue';
import Register  from '@/views/login/register.vue';
import {getUserInfo} from "@/api/user";
import {
  getStreamingList,
} from "@/api/stream";
import avatar from "@/assets/photo.png";

export default {
  name: "TopBar",
  components: {LoginName, Register},
  data() {
    return {
      showLogin: false,
      showRegister: false,
      content: "",
      avatar: avatar,
      tab: -1,
      form: {
        sex: 1,
        avatar: "",
        username: "",
        industry: "",
        mobile: "",
        position: "",
        company: "",
        email: "",
        department: "",
        name: "",
      },
    };
  },
  computed: {},
  watch: {
    tab: function (val) {
      this.getStreamingList(val);
      if (val == -1) {
        this.$router.push('/')
      } else if (val == 1) {
        this.$router.push('/all-list')
      } else if (val == 2) {
        this.$router.push('/top-list')
      }
    },
  },
  created() {
    getUserInfo().then((res) => {
      if (res.code == 200) {
        this.form.avatar = res.data.avatar;
        this.form.name = res.data.name;
        this.form.username = res.data.username;
        this.form.sex = res.data.sex;
        this.form.mobile = res.data.mobile;
        this.form.email = res.data.email;
        this.form.company = res.data.company;
        this.form.position = res.data.position;
        this.form.industry = res.data.industry;
        this.form.department = res.data.department;
      }
    });
    let location = window.location.href
     console.log(location)
    if (location.includes("top-list")) {
      this.tab = 2
    }
    if (location.includes("all-list")) {
      this.tab = 1
    }
    if (location.includes("login") || location.includes("register") || location.includes("anchor-detail")
        || location.includes("profile") || location.includes("streaming-page")) {
      this.tab = 0
    }
  },
  methods: {
    goTab(){
      this.$refs['loginName'].showlogin()
      // this.tab = 2
    },
    getStreamingList() {
      getStreamingList({
        status: this.tab == -1 ? undefined : this.tab,
      }).then((res) => {
        if (res.code == 200) {
          this.list = res.data.data;
        }
      });
    },
    search(e) {
      if (e.keyCode == 13) {
        if (this.$route.path.includes("/search")) {
          this.$router.replace("/search?content=" + this.content);
        } else {
          this.$router.push("/search?content=" + this.content);
        }
        this.tab = ''
        this.content = "";
      }
    },
    goMyList() {
      this.$router.push('/profile')
      this.tab = ''
    },
    go() {
      this.tab = ''
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push("/");
      this.tab = -1
    },
  },
};
</script>
<style lang="scss" scoped>
.hover-effect {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
  width: 100px;
  text-align: center!important;
}
#top-bar {
  background: #fff;
  .top-container {
    width: 100%;
    min-width: 1180px;
    max-width: 2430px;
    margin: 0 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);

    .logo {
      padding-left: 20px;
      height: 30px;
      cursor: pointer;
    }
    .logo1 {
      padding-left: 20px;
      height: 20px;
      cursor: pointer;
    }
    .right {
      display: flex;
      align-items: center;
      margin-right: 45px;
      .category {
        display: flex;

        .category-wrap {
          cursor: pointer;
          font-size: 20px;
          height: 45px;
          line-height: 45px;
          border-bottom: 4px solid transparent;
          text-align: center;
          white-space: nowrap;
          color: rgb(12, 90, 31);
          font-family: SourceHanSansCN-Medium;
          width: 130px;
        }

        .active {
          background-color: rgb(12, 90, 31);
          box-shadow: 0px 3px 13px rgba(0, 0, 0, 0.13);
          border-radius: 10px;
          color: white;
          font-size: 20px;
        }

        //.category-wrap:nth-child(1) {
        //  margin-right: 40px;
        //}
      }

      .search-bar {
        height: 45px;
        position: relative;
        background: rgb(255, 255, 255) !important;
        border: 1px solid rgb(144, 188, 156);
        box-shadow: 0px 3px 13px rgba(0, 0, 0, 0.13);;
        border-radius: 10px;
        z-index: 100;
        margin-left: 40px;
        input {
          transition-duration: 0.2s;
          font-size: 20px;
          border-radius: 10px;
          background: #fff;
          color: rgb(12, 90, 31);
          padding-left: 52px;
          width: 260px;
          height: 100%;
        }
        input::-webkit-input-placeholder {
          color: #ABC6BD;
        }
        .search-icon {
          position: absolute;
          width: 22px;
          height: 22px;
          left: 12px;
          top: 12px;
        }
        .border{
          width: 25px;
          height: 0;
          border: 0.1px solid #abc6bd;
          transform: rotate(-90deg);
          position: absolute;
          top: 22px;
          left: 32px;
        }
      }

      .top-btn {
        font-size: 20px;
        color: rgb(12, 90, 31);
        //font-weight: bold;
        //margin-left: 30px;
        cursor: pointer;
      }

      .user-avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 1px solid #90BC9C;
        //margin-left: 16px;
      }
    }

    .right:hover {
      input {
        box-shadow: 0px 0px 4px 1px rgba(92, 35, 59, 0.2);
      }
    }
  }
}
</style>
